import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'stay-mgmt-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  @Input() messages;
  @Input() checked;
  @Input() disabled: boolean;
  @Input() dataSlnmIhg: string;
  @Output() boxClicked: EventEmitter<string>;

  constructor() {
    this.boxClicked = new EventEmitter();
  }

  ngOnInit() {
  }

  onCheckboxClick(): void {
    //  ONE WAY BINDING!!!!
    //  WE DO NOT UPDATE THE COMPONENT VARIABLE BECAUSE IT IS MANAGED BY STATE.
    //  WE JUST RAISE THE EVENT AND LET IT BE HANDLED BY WHOMEVER.
    //  IT IS THE JOB OF THE EVENT HANDLING THE EVENT TO MANAGE THE STATE.
    //  THIS IS SO THE STATE OF THE CHECK BOX CAN BE SHARED THROUGH OUT ALL COMPONENTS.
    this.boxClicked.emit((!this.checked).toString());
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/checkbox/checkbox.component.ts